export enum PaymentChannelTypeSlug {
  SALE = 'sale',
  PORTAL = 'portal',
}
